import React from 'react';
import { Section } from './ui/Section';
import { CheckCircle2, Layers, Lock } from 'lucide-react';
export function SolutionSection() {
  return <Section background="dark" className="relative overflow-hidden" data-id="element-316">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-amber-500/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-317"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-amber-600/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-318"></div>

      <div className="relative z-10 flex flex-col md:flex-row items-center gap-12" data-id="element-319">
        <div className="flex-1" data-id="element-320">
          <div className="inline-block px-4 py-1.5 rounded-full border border-amber-500/30 bg-amber-500/10 text-amber-400 font-semibold text-sm mb-6" data-id="element-321">
            Presentando Barrier Shield Technology™
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-6 leading-tight" data-id="element-322">
            Ingeniería de Capas: <br data-id="element-323" />
            <span className="text-amber-400" data-id="element-324">El Escudo de Cristal</span>
          </h2>
          <p className="text-stone-300 text-lg mb-8 leading-relaxed" data-id="element-325">
            He decodificado la técnica de las altas pastelerías francesas para
            que puedas replicarla en tu casa. No necesitas herramientas
            costosas, necesitas entender la ciencia.
          </p>

          <ul className="space-y-6" data-id="element-326">
            <li className="flex items-start gap-4" data-id="element-327">
              <div className="mt-1 bg-amber-500/20 p-2 rounded-lg" data-id="element-328">
                <Lock className="w-5 h-5 text-amber-400" data-id="element-329" />
              </div>
              <div data-id="element-330">
                <h4 className="text-white font-bold text-lg" data-id="element-331">
                  Sellado Térmico
                </h4>
                <p className="text-stone-400" data-id="element-332">
                  Aprenderás a crear una barrera invisible de azúcar
                  caramelizada que actúa como un cristal.
                </p>
              </div>
            </li>
            <li className="flex items-start gap-4" data-id="element-333">
              <div className="mt-1 bg-amber-500/20 p-2 rounded-lg" data-id="element-334">
                <Layers className="w-5 h-5 text-amber-400" data-id="element-335" />
              </div>
              <div data-id="element-336">
                <h4 className="text-white font-bold text-lg" data-id="element-337">
                  Aislamiento de Humedad
                </h4>
                <p className="text-stone-400" data-id="element-338">
                  Impide físicamente que la humedad de la crema toque las capas
                  de hojaldre.
                </p>
              </div>
            </li>
            <li className="flex items-start gap-4" data-id="element-339">
              <div className="mt-1 bg-amber-500/20 p-2 rounded-lg" data-id="element-340">
                <CheckCircle2 className="w-5 h-5 text-amber-400" data-id="element-341" />
              </div>
              <div data-id="element-342">
                <h4 className="text-white font-bold text-lg" data-id="element-343">
                  Durabilidad Extrema
                </h4>
                <p className="text-stone-400" data-id="element-344">
                  Tu Mil Hojas se mantendrá crujiente por 48 horas, incluso en
                  climas húmedos.
                </p>
              </div>
            </li>
          </ul>
        </div>

        <div className="flex-1 w-full" data-id="element-345">
          <div className="bg-stone-800 border border-stone-700 rounded-2xl p-8 relative overflow-hidden group hover:border-amber-500/50 transition-colors duration-300" data-id="element-346">
            <div className="absolute top-0 right-0 bg-amber-500 text-stone-900 text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-347">
              MÉTODO PRO
            </div>

            <h3 className="text-2xl font-serif text-white mb-6" data-id="element-348">
              Lo que vas a lograr
            </h3>

            <div className="space-y-4" data-id="element-349">
              <div className="flex items-center justify-between p-4 bg-stone-900/50 rounded-lg border border-stone-700" data-id="element-350">
                <span className="text-stone-300" data-id="element-351">Crujido (Decibelios)</span>
                <div className="flex items-center gap-2" data-id="element-352">
                  <div className="w-24 h-2 bg-stone-700 rounded-full overflow-hidden" data-id="element-353">
                    <div className="h-full bg-amber-500 w-[95%]" data-id="element-354"></div>
                  </div>
                  <span className="text-amber-400 font-mono font-bold" data-id="element-355">
                    ALTO
                  </span>
                </div>
              </div>

              <div className="flex items-center justify-between p-4 bg-stone-900/50 rounded-lg border border-stone-700" data-id="element-356">
                <span className="text-stone-300" data-id="element-357">Integridad Estructural</span>
                <div className="flex items-center gap-2" data-id="element-358">
                  <div className="w-24 h-2 bg-stone-700 rounded-full overflow-hidden" data-id="element-359">
                    <div className="h-full bg-amber-500 w-[100%]" data-id="element-360"></div>
                  </div>
                  <span className="text-amber-400 font-mono font-bold" data-id="element-361">
                    100%
                  </span>
                </div>
              </div>

              <div className="flex items-center justify-between p-4 bg-stone-900/50 rounded-lg border border-stone-700" data-id="element-362">
                <span className="text-stone-300" data-id="element-363">Tiempo de Vida</span>
                <div className="flex items-center gap-2" data-id="element-364">
                  <div className="w-24 h-2 bg-stone-700 rounded-full overflow-hidden" data-id="element-365">
                    <div className="h-full bg-amber-500 w-[90%]" data-id="element-366"></div>
                  </div>
                  <span className="text-amber-400 font-mono font-bold" data-id="element-367">
                    48H+
                  </span>
                </div>
              </div>
            </div>

            <div className="mt-8 pt-6 border-t border-stone-700 text-center" data-id="element-368">
              <p className="text-stone-400 italic" data-id="element-369">
                "Es como ponerle un impermeable invisible a tu postre"
              </p>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}